import React from 'react'
import FirebaseContext from "../../firebase/context";
import {
    Container,
    Paper,
    Grid,
    Typography,
    TextField,
    CardMedia,
    Card,
    CardContent,
    CardActions,
    Button,
    TableContainer,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
} from "@material-ui/core";
import { Link, withRouter } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import DoneAllIcon from '@material-ui/icons/DoneAll';
import CompExamenPreguntas from '../components/CompExamenPreguntas';
import CompAdminExamenItem from '../components/CompAdminExamenItem';
import CompExamenesItem from '../components/CompExamenesItem';
import CancelIcon from '@material-ui/icons/Cancel';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import { Column, Row } from '@mui-treasury/components/flex';
import UsuarioContext from '../contex/UsuarioContext';


const useStyles = makeStyles((theme) => ({
    button: {
        margin: theme.spacing(1),
    },
    margin: {
        margin: theme.spacing(1),
    },
}));


const style = {
    container: {
        width: '100%',
    },
    cardGrid: {
        paddingTop: 8,
        paddingBottom: 8
    },
    paper: {
        backgroundColor: "#f5f5f5",
        padding: "20px",

    },
    paperMenu: {
        backgroundColor: "#f5f5f5",
        padding: "20px",

    },
    link: {
        display: "flex"
    },
    gridTextfield: {
        marginTop: "20px"
    },
    card: {
        height: "100%",
        display: "flex",
        flexDirection: "column",
        backgroundColor: "#B5DEF1",
    },
    cardMedia: {
        paddingTop: "56.25%"
    },
    cardContent: {
        flexGrow: 1
    },
    barraBoton: {
        marginTop: "20px"
    }
};

const PagExamen = (props) => {
    const classes = useStyles();

    const { firebase, user } = React.useContext(FirebaseContext);
    const examenId = props.match.params.examenId;
    const [ranking, setRanking] = React.useState([])
    const [examen, setExamen] = React.useState({
        aTituloExamen: "",
        bPuntajeTotal: "",
        bFechaExamen: "",
        bUrlExamen: "",
        cEstado: 0,
        cRespuestas: [],
        dPuntajes: [],
        eAlumnos: [],
    })
    const [examenAlumno, setExamenAlumno] = React.useState({
        UserId: "",
        UserName: "",
        bPuntajeTotal: "",
        cFinalizado: false,
        cRespuestas: [],
        dPuntajes: [],
    })

    ////////////////////////////////////////////////////////////////////  
    const usuarioContextLocal = React.useContext(UsuarioContext);
    const { setObjUsuario, objUsuario } = usuarioContextLocal;

    // React.useEffect(() => {
    //     firebase.db.collection("colUsuarios").where("id", "==", user.uid).get().then(snapshot => {
    //         const arrayUsuario = snapshot.docs.map(doc => {
    //             let data = doc.data();
    //             let id = doc.id;
    //             return { id, ...data };
    //         });
    //         setObjUsuario(arrayUsuario[0]);
    //     });
    // }, [])
    ///////////////////////////////////////////////////////////////////////////
    React.useEffect(() => {
        getExamenes();
    }, []);
    console.log('examen');
    console.log(examen);

    function getExamenes() {

        firebase.db.collection("colExamenes").get().then(snapshot => {
            const objExamenes = snapshot.docs.map(doc => {
                let data = doc.data();
                let id = doc.id;


                return { id, ...data };
            });
            const resultado = objExamenes.find(item => item.id === examenId);
            resultado.eAlumnos.forEach((alumno) => {
                if (alumno.UserId == user.uid)
                    setExamenAlumno(alumno)
            })
            let ranking = resultado.eAlumnos

            ranking.sort(((a, b) => b.bPuntajeTotal - a.bPuntajeTotal));
            setRanking(ranking)
            setExamen(resultado);

            

        });
    }

    function respuestaSave() {
        const examenRef = firebase.db.collection("colExamenes").doc(examenId);
        let total = 0
        examenAlumno.dPuntajes.forEach((a) => { total += a })

        let newObjectDB = { ...examenAlumno }
        newObjectDB.UserId = user.uid;
        newObjectDB.UserName = objUsuario.nombre;
        newObjectDB.bPuntajeTotal = total;
        newObjectDB.cFinalizado = true;

        examenRef.get().then(doc => {
            if (doc.exists) {
                const previousAlumnos = doc.data().eAlumnos;
                const updatedAlumnos = [...previousAlumnos, newObjectDB];
                examenRef.update({ eAlumnos: updatedAlumnos });
                setExamenAlumno(newObjectDB);
            }
        });
    }



    return (

        <Container style={style.container}>
            <Grid container spacing={1}>


                {
                    examen.cEstado >= 2 ? (
                        <Grid item xs={10} sm={8} style={style.gridTextfield}>
                            <Paper style={style.paper}>
                                <Grid container spacing={2}>

                                <TableContainer component={Paper}>
                                        <Table className={classes.table} size="small" aria-label="a dense table">
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell color="Primary">RANKING</TableCell>
                                                </TableRow>
                                            </TableHead>
                                        </Table>
                                    </TableContainer>


                                    <TableContainer component={Paper}>
                                        <Table className={classes.table} size="small" aria-label="a dense table">
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell>Puesto</TableCell>
                                                    <TableCell align="left">Puntaje</TableCell>
                                                    <TableCell align="left">Nombre</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {ranking.map((alumno, index) => (
                                                    <TableRow key={index}>
                                                        <TableCell component="th" scope="row">
                                                            {index + 1}
                                                        </TableCell>
                                                        <TableCell align="left">{alumno.bPuntajeTotal}</TableCell>
                                                        <TableCell align="left">{alumno.UserName}</TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>

                                    <Grid item xs={12} sm={12} style={style.gridTextfield}>
                                        <Card style={style.card}>
                                            <CardActions>
                                                <CardMedia
                                                    component="iframe"
                                                    height="800"
                                                    image={examen.bUrlExamen}
                                                    title="Contemplative Reptile" />
                                            </CardActions>
                                        </Card>
                                    </Grid>
                                </Grid>
                            </Paper>
                        </Grid>
                    ) : null
                }


                {
                    examen.cEstado >= 4 ? (
                        <Grid item xs={12} sm={8} style={style.gridTextfield}>
                            <Paper style={style.paperMenu}>
                                <Grid container spacing={2}>

                                <TableContainer component={Paper}>
                                        <Table className={classes.table} size="small" aria-label="a dense table">
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell color="Primary">RANKING</TableCell>
                                                </TableRow>
                                            </TableHead>
                                        </Table>
                                    </TableContainer>


                                    <TableContainer component={Paper}>
                                        <Table className={classes.table} size="small" aria-label="a dense table">
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell>Puesto</TableCell>
                                                    <TableCell align="left">Puntaje</TableCell>
                                                    <TableCell align="left">Nombre</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {ranking.map((alumno, index) => (
                                                    <TableRow key={index}>
                                                        <TableCell component="th" scope="row">
                                                            {index + 1}
                                                        </TableCell>
                                                        <TableCell align="left">{alumno.bPuntajeTotal}</TableCell>
                                                        <TableCell align="left">{alumno.UserName}</TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>

                                </Grid>
                            </Paper>
                        </Grid>
                    ) : null
                }


{
                    examen.cEstado == 2 & !examenAlumno.cFinalizado ? (

                        <Grid item xs={12} sm={4} style={style.gridTextfield}>
                            <Paper style={style.paperMenu}>
                                <Grid container spacing={1}>

                                    <TableContainer component={Paper}>
                                        <Table className={classes.table} size="small" aria-label="a dense table">
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell color="Primary">{examen.aTituloExamen}</TableCell>
                                                    <TableCell color="Primary"></TableCell>
                                                    <TableCell color="Primary">
                                                        <Button
                                                            variant="contained"
                                                            color="primary"
                                                            size="small"
                                                            className={classes.button}
                                                            startIcon={<DoneAllIcon />}
                                                            onClick={() => respuestaSave()}
                                                        >
                                                            TERMINAR
                                                           </Button>
                                                    </TableCell>
                                                </TableRow>
                                            </TableHead>
                                        </Table>
                                    </TableContainer>


                                    <TableContainer component={Paper}>
                                        <Table className={classes.table} size="small" aria-label="a dense table">
                                            <TableHead>
                                                <TableRow>
                                                    {/* <TableCell></TableCell>
                                                        <TableCell align="right">Respuestas</TableCell> */}
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {examen.cRespuestas.map((respuesta, index) => (
                                                    <TableRow key={index}>
                                                        <TableCell component="th" scope="row">
                                                            {index + 1}
                                                        </TableCell>
                                                        <TableCell align="right">
                                                            <CompExamenPreguntas
                                                                key={index}
                                                                respuesta={respuesta}
                                                                setExamen={setExamen}
                                                                examen={examen}
                                                                setExamenAlumno={setExamenAlumno}
                                                                examenAlumno={examenAlumno}
                                                                index={index + 1}
                                                            />
                                                        </TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>

                                </Grid>
                            </Paper>
                        </Grid>
                    ) : null
                }


                {
                    examen.cEstado >= 2 & examenAlumno.cFinalizado ? (
                        <Grid item xs={12} sm={4} style={style.gridTextfield}>
                            <Paper style={style.paperMenu}>
                                <Grid container spacing={2}>

                                    <TableContainer component={Paper}>
                                        <Table className={classes.table} size="small" aria-label="a dense table">
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell color="Primary">{examen.aTituloExamen}</TableCell>
                                                    <TableCell>TOTAL: </TableCell>
                                                    <TableCell align="right">{examenAlumno.bPuntajeTotal}</TableCell>
                                                </TableRow>
                                            </TableHead>
                                        </Table>
                                    </TableContainer>

                                    <TableContainer component={Paper}>
                                        <Table className={classes.table} size="small" aria-label="a dense table">
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell>Preguntas</TableCell>
                                                    <TableCell align="right">Respuestas</TableCell>
                                                    <TableCell align="right">Aciertos</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {examenAlumno.cRespuestas.map((respuesta, index) => (
                                                    <TableRow key={index}>
                                                        <TableCell component="th" scope="row">
                                                            Pregunta {index + 1}
                                                        </TableCell>
                                                        <TableCell align="right">{respuesta}</TableCell>
                                                        <TableCell align="right">{examenAlumno.dPuntajes[index]}</TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </Grid>
                            </Paper>
                        </Grid>
                    ) : null
                }

              
                {/* {
                    examen.cEstado == 2 & examenAlumno.cFinalizado ? (
                        <Grid item xs={12} sm={4} style={style.gridTextfield}>
                            <Paper style={style.paperMenu}>
                                <Grid container spacing={2}>

                                    <TableContainer component={Paper}>
                                        <Table className={classes.table} size="small" aria-label="a dense table">
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell color="Primary">{examen.aTituloExamen}</TableCell>
                                                    <TableCell>TOTAL: </TableCell>
                                                    <TableCell align="right">{examenAlumno.bPuntajeTotal}</TableCell>
                                                </TableRow>
                                            </TableHead>
                                        </Table>
                                    </TableContainer>
                                </Grid>
                            </Paper>
                        </Grid>
                    ) : null
                } */}

                {
                    examen.cEstado == 1 ? (
                        <Grid item xs={12} sm={12} style={style.gridTextfield}>
                            <Paper style={style.paperMenu}>
                                <Grid container spacing={2}>

                                    <TableContainer component={Paper}>
                                        <Table className={classes.table} size="small" aria-label="a dense table">
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell color="Primary">{examen.aTituloExamen}</TableCell>
                                                    <TableCell>Examen no iniciado </TableCell>
                                                    <TableCell align="right"></TableCell>
                                                </TableRow>
                                            </TableHead>
                                        </Table>
                                    </TableContainer>
                                </Grid>
                            </Paper>
                        </Grid>
                    ) : null
                }













            </Grid>
        </Container>
    )
}

export default withRouter(PagExamen)
